import { Theme } from '@material-ui/core';
import { CSSProperties } from 'react';
import { shadow } from './colors';

export const paperBoxShadow = `0 6px 16px ${shadow}`;
export const smallBoxShadow = `0 0 6px ${shadow}`;
export const borderRadius = 8;
export const paperBorderRadius = 8;

export const getMainBoxSpacing = ({
  isUpSm,
  isUpLg,
}: {
  isUpSm: boolean;
  isUpLg: boolean;
}): 2 | 3 | 4 => {
  switch (true) {
    case isUpLg:
      return 4;
    case isUpSm:
      return 3;
    default:
      return 2;
  }
};

export const getDefaultPaperStyle = ({
  theme,
  isUpSm,
  isUpLg,
}: {
  theme: Theme;
  isUpSm: boolean;
  isUpLg: boolean;
}): CSSProperties => {
  const { spacing } = theme;
  const spacingValue = getMainBoxSpacing({ isUpSm, isUpLg });
  return {
    marginTop: spacing(spacingValue),
  };
};

export default {
  borderRadius,
  paperBorderRadius,
  paperBoxShadow,
  getMainBoxSpacing,
  getDefaultPaperStyle,
};
